import React, { useState } from 'react';
import { Row, Col, Button } from 'react-bootstrap';
import PrivacyPolicy from './PrivacyPolicy';

function Form(props) {
    // State to hold the email input value
    const [email, setEmail] = useState('');
    // State to hold the success message
    const [successMessage, setSuccessMessage] = useState('');

    // Function to handle successful submission
    const handleSuccess = () => {
        setSuccessMessage(props.formSuccessLabel);
    };

    const handleError = () => {
        setSuccessMessage(props.formErrorLabel);
    };

    // Function to handle changes in the email input
    const handleEmailChange = (e) => {
        setEmail(e.target.value);
    };

    // Function to handle form submission
    const handleSubmit = async (e) => {
        e.preventDefault();
        // You can perform any action with the email value here, like sending it to a server
        //console.log('Submitted email:', email);
        // Optionally, you can clear the email input after submission

        try {
            const response = await fetch(props.envVars.REACT_APP_API_URL, {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                },
                body: JSON.stringify({
                    "email": [email],
                    "market": props.market,
                    "brand": props.brand,
                }), // Send email data in the request body
            })

            if (!response.ok) {
                handleError();
                throw new Error('Failed to submit email');
            }
            //console.log('Email submitted successfully');
            handleSuccess();

        } catch (error) {
            console.error('Error submitting email:', error.message);
            handleError();
        }

        setEmail('');
       // console.log(JSON.stringify(props.envVars));
        // console.log(JSON.stringify(props.envVars.REACT_APP_API_URL));
    };

    return (
        <div className="d-flex justify-content-center">
            <form onSubmit={handleSubmit}>
                <div>
                    <Row className="mb-1">
                        <Col>
                            <label
                                htmlFor="email">
                                {props.emailInputLabel}
                            </label>
                        </Col>
                    </Row>
                    <Row className="mb-1">
                        <Col>
                            <input
                                type="email"
                                id="email"
                                value={email}
                                onChange={handleEmailChange}
                                placeholder=""
                                required // Input is required
                            />
                        </Col>
                    </Row>
                    <Row className="mt-3">
                        <Col>
                            <Button className="form-button" variant="dark" type="submit">
                                {props.submitButton}
                            </Button>
                        </Col>
                    </Row>
                    <Row>
                        <Col>
                            {successMessage && successMessage.length > 0 && <p>{successMessage}</p>}
                        </Col>
                    </Row>
                </div>
            </form>
        </div>
    );
}

export default Form;
